module.exports = __webpack_public_path__ + "static/img/2@2x.dafb313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barometer/2@2x.png
// module id = 4LqY
// module chunks = 1